// https://vuex.vuejs.org/en/getters.html

// authorized lets you know if the token is true or not
export default {
  authorized: state => !!state.token,
  authstatus: state => state.authStatus,
  runningtime: state => state.running_time,
  numFiltrosAplicados(state){
    return Object.values(state.filtros).reduce( (acc,value) => value ? acc + 1 : acc, 0);
  }
};
